// extracted by mini-css-extract-plugin
export var divider = "_pp-0";
export var systemMessage = "_pp-1";